import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'
import cx from 'classnames'

import styles from './subtabs.styl'

const enhance = compose(
  connect(({ app }, props) => ({
    activeTab: app.tabs[props.id]
  }))
)

class SubTabs extends Component {
  static propTypes = {
    activeTab: PropTypes.number,
    organisationId: PropTypes.string,
    overview: PropTypes.object,
    children: PropTypes.any,
    defaultActive: PropTypes.number,
    onChange: PropTypes.func,
    equalWidth: PropTypes.bool,
    compact: PropTypes.bool
  }
  static defaultProps = {}

  constructor(props) {
    super(props)

    this.state = {
      activeId: props.defaultActive || 0
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.activeId !== nextProps.activeTab &&
      Number(nextProps.activeTab) > -1
    ) {
      this.setState({
        activeId: nextProps.activeTab || nextProps.defaultActive || 0
      })
    }
  }

  handleClick = id => {
    this.setState({
      activeId: id
    })
    if (this.props.onChange) {
      this.props.onChange(id)
    }
  }

  handleGetCountNumber = (counterNameId = '') => {
    // this logic is very similar to logic in tabs - should be unified
    const { overview, organisationId } = this.props
    let counts = []
    let list = overview.list

    if (organisationId) {
      list = overview.byId[organisationId] || overview.list
    }

    counts = counts.concat(
      list.filter(item => item.nameId === counterNameId).map(item => item.value)
    )

    const count = counts.reduce((acc, cv) => {
      return acc + cv
    }, 0)

    if (count === 0) {
      return null
    }

    return <span className={styles.progress}>{count}</span>
  }

  renderTabs = tabs => (
    <ul className={styles.list}>
      {tabs.map((tab, index) => {
        return (
          <li
            key={index}
            className={`${styles.item} ${cx({
              [styles.aside]: tab.aside,
              [styles.equalWidth]: this.props.equalWidth,
              [styles.withImage]: tab.svg,
              [styles.compact]: this.props.compact
            })}  `}
            onClick={() => this.handleClick(tab.id)}
          >
            <span
              className={`${styles.tab} ${this.state.activeId === tab.id ? styles.active : ''}`}
            >
              {tab.icon &&
                <span className={`ico ico--${tab.icon} ${styles.icon}`} />}
              {tab.svg &&
                <img
                  src={require(`assets/img/${tab.svg}.svg`).default}
                  className={styles.image}
                  alt={tab.svg}
                />}
              {tab.intlKey
                ? <FormattedMessage
                    id={tab.intlKey}
                    defaultMessage={tab.title}
                  />
                : tab.title}
              {tab.progress && tab.progress > 0
                ? <span className={styles.progress}>{tab.progress}</span>
                : null}
              {tab.tasks
                ? <span className={styles.progress}>
                    {tab.tasks > 19 ? '19+' : tab.tasks}
                  </span>
                : null}
              {tab.counter && this.handleGetCountNumber(tab.counter)}
            </span>
          </li>
        )
      })}
    </ul>
  )

  render() {
    const { children } = this.props
    const { activeId } = this.state
    const content = [].concat(children).filter(item => item)

    const tabs = content.filter(item => item).map((item, index) => ({
      title: item.props.title,
      id: index,
      icon: item.props.icon,
      svg: item.props.svg,
      aside: item.props.aside,
      intlKey: item.props.intlKey,
      progress: item.props.progress,
      counter: item.props.counter,
      tasks: item.props.tasks
    }))

    return (
      <div>
        {this.renderTabs(tabs)}
        {content[activeId]}
      </div>
    )
  }
}

export default enhance(SubTabs)
